import React, { useState } from 'react';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import { UserPlusIcon, UserMinusIcon } from 'lucide-react';
import { OnboardingWizard } from './pages/OnboardingWizard';
import { Logo } from './components/Logo';
export function App() {
  const [mode, setMode] = useState<'onboarding' | 'offboarding' | null>(null);
  return <LayoutGroup data-id="element-0" data-mp="3f8ex7egrljrk">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="2rkx5fixi2lol">
        {mode === null ? <motion.div key="splash" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.3
        }
      }} className="min-h-screen w-full bg-[#F0F2F5] flex flex-col items-center justify-center p-4 font-sans" data-id="element-2" data-mp="2rl6vt7mgiuut">
            <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-center mb-12" data-id="element-3" data-mp="23vkvuhy9gblr">
              <Logo size="lg" className="mx-auto mb-5" data-id="element-4" data-mp="3reltgdimfc74" />
              <h1 className="text-xl font-medium text-gray-500 tracking-wide" data-id="element-5" data-mp="4wylxj0jajy">
                User Management Console
              </h1>
            </motion.div>

            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-6" data-mp="33mf2jtvnzxf3">
              <motion.button layoutId="onboarding-toggle" onClick={() => setMode('onboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-navy-600 text-white rounded-xl shadow-lg hover:bg-navy-700 hover:shadow-xl hover:-translate-y-0.5 transition-[transform,box-shadow,background-color] duration-200 ease-out group" data-id="element-7" data-mp="stc7s3fgqynd">
                <UserPlusIcon className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" data-id="element-8" data-mp="8649ngaig8a1" />
                <span className="text-base font-semibold" data-id="element-9" data-mp="3glwg68b7uy0t">Onboarding</span>
              </motion.button>

              <motion.button layoutId="offboarding-toggle" onClick={() => setMode('offboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-white text-gray-700 border border-gray-200 rounded-xl shadow-sm hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 group" data-id="element-10" data-mp="3bo4kr4bd4trv">
                <UserMinusIcon className="w-5 h-5 mr-3 text-gray-500 group-hover:scale-110 transition-transform" data-id="element-11" data-mp="2svafx37gei1d" />
                <span className="text-base font-semibold" data-id="element-12" data-mp="18boj8j2po5vd">Offboarding</span>
              </motion.button>
            </motion.div>
          </motion.div> : <motion.div key="wizard" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="w-full" data-id="element-13" data-mp="ygmtpm4ix1s9">
            <OnboardingWizard mode={mode} setMode={setMode} data-id="element-14" data-mp="1w2tyaw0tuu4m" />
          </motion.div>}
      </AnimatePresence>
    </LayoutGroup>;
}